import React from 'react'
import { any, async, fromJSX, nothing, onlyIf, Updater, Widget } from 'widgets-for-react'
import { NotFoundLayout } from '../notFound/notFoundLayout'
import { CourseDateScheduleLayout } from './courseDateScheduleLayout'
import { CourseDateScheduleStateUpdaters, CourseDateScheduleState} from './courseDateScheduleState'
import { EventTemplate } from '../models/Events/Events'

export const courseDateScheduleWidget = (
  state: CourseDateScheduleState
): Widget<Updater<CourseDateScheduleState>> => {
  const eventTemplateData = state.eventTemplateData
  return any<Updater<CourseDateScheduleState>>([
    async<EventTemplate>(state.eventTemplateData, () => nothing(), { otherError: fromJSX(() => <NotFoundLayout></NotFoundLayout>) }).map(CourseDateScheduleStateUpdaters.updateEventData),
    eventTemplateData.kind == "loaded"
      ? fromJSX(() => <CourseDateScheduleLayout rf={state.rf} eventTemplateData={eventTemplateData.value} eventId={state.eventId} />)
      : nothing()
  ])
}
